import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// Intercept all fetch calls going to the API and inject X-App-Source.
// This covers every component — no need to update individual fetch calls.
const API_URL = process.env.REACT_APP_API_URL;
const _fetch = window.fetch;
window.fetch = (input, init = {}) => {
    const url = typeof input === 'string' ? input : input instanceof Request ? input.url : String(input);
    if (url.startsWith(API_URL)) {
        init = {
            ...init,
            headers: { 'X-App-Source': 'candidate-app', ...init.headers },
        };
    }
    return _fetch(input, init);
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
);
